export default function FakeQR({ seed = "bwpay", size = 150, className = "" }) {
  const n = 21;
  let h = 7;
  for (let i = 0; i < seed.length; i++) h = (h * 131 + seed.charCodeAt(i)) >>> 0;
  const rnd = (i) => {
    const x = Math.sin((h % 100000) + i * 12.9898) * 43758.5453;
    return x - Math.floor(x);
  };
  const finderVal = (r, c) => {
    const zones = [
      [0, 0],
      [0, n - 7],
      [n - 7, 0],
    ];
    for (const [zr, zc] of zones) {
      if (r >= zr && r < zr + 7 && c >= zc && c < zc + 7) {
        const rr = r - zr;
        const cc = c - zc;
        const d = Math.max(Math.abs(rr - 3), Math.abs(cc - 3));
        return d === 3 || d <= 1;
      }
    }
    return null;
  };
  const cells = [];
  for (let r = 0; r < n; r++) {
    for (let c = 0; c < n; c++) {
      const f = finderVal(r, c);
      const on = f !== null ? f : r === 6 || c === 6 ? (r + c) % 2 === 0 : rnd(r * n + c) > 0.52;
      cells.push(on);
    }
  }
  return (
    <div
      data-testid="payment-qr"
      className={`grid aspect-square w-full rounded-xl bg-white p-[7%] ${className}`}
      style={{ gridTemplateColumns: `repeat(${n}, 1fr)`, maxWidth: size }}
    >
      {cells.map((on, i) => (
        <div key={i} className={on ? "bg-black" : "bg-transparent"} />
      ))}
    </div>
  );
}
